import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, ArrowLeft } from 'lucide-react';

export const Breadcrumbs = ({ items = [], onBack }) => {
  return (
    <div className="flex items-center space-x-2 mb-6" data-testid="breadcrumbs">
      {onBack && (
        <button
          onClick={onBack}
          data-testid="back-button"
          className="mr-2 p-1.5 rounded-sm hover:bg-slate-100 transition-colors text-slate-500 hover:text-slate-900"
        >
          <ArrowLeft className="w-4 h-4" />
        </button>
      )}
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <ChevronRight className="w-4 h-4 text-slate-400 flex-shrink-0" />}
          {item.to ? (
            <Link
              to={item.to}
              data-testid={`breadcrumb-${index}`}
              className="text-sm text-slate-500 hover:text-slate-900 transition-colors truncate max-w-[160px]"
            >
              {item.label}
            </Link>
          ) : (
            <span
              data-testid={`breadcrumb-${index}`}
              className="text-sm font-medium text-slate-900 truncate max-w-[200px]"
            >
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
